import { FC, memo, useState } from 'react';
import { useSelector } from 'react-redux';
import useUploadCheck from '../CustomizationSection/hooks/useUploadCheck';
import { useVideoData, VideoSizes } from '@anm/hosting-player';
import { uploadsSelectors } from '@anm/store/modules/uploads';
import { hostedVideoSelectors } from '../../../store/modules/hostedVideo';
import PlayerBlock from '../CustomizationSection/RightPanel/PlayerBlock';
import { projectSelectors } from '../../../store/modules/project';
import useFetchProjectById from '../CustomizationSection/hooks/useFetchProjectById';
import { FadeInWrapper, Placeholder } from './styles';
import Loader from '@anm/components/Loader';

type CmpProps = {
  projectId: string;
  hostId?: string;
  playerSizes?: VideoSizes;
};

const Player: FC<CmpProps> = ({ hostId, projectId, playerSizes }) => {
  useFetchProjectById(projectId);
  const [inited, setInited] = useState(false);
  const [_, isUploadExists] = useUploadCheck({ projectId });
  const isUploading = useSelector(uploadsSelectors.selectUploadPending);
  const createdUpload = useSelector(uploadsSelectors.selectLatestUpload);
  const id = hostId || createdUpload?.hostId;
  const getManifestPending = useSelector(hostedVideoSelectors.selectGetManifestPending);
  const projectSizes = useSelector(projectSelectors.selectCurrentProjectSizes) as VideoSizes;

  const { videoData, errorCode, errorMessage } = useVideoData({
    hostId: id || '',
    source: 'api'
  });

  const { sizes: videoSizes } = videoData || {};
  const sizes = videoSizes?.width ? videoSizes : projectSizes;

  const canShowPlayer = !isUploading && isUploadExists && !getManifestPending && videoData;

  if (!id) return null;

  return (
    <Placeholder sizes={playerSizes}>
      {!inited && <Loader size="large2" color="blue" />}
      {canShowPlayer && (
        <FadeInWrapper {...{ inited }}>
          <PlayerBlock
            {...{ sizes, projectId, errorCode, errorMessage, playerSizes }}
            hostId={id}
            onInit={() => setInited(true)}
            videoData={videoData ? { ...videoData, configs: { ...videoData.configs, autoplay: true } } : null}
          />
        </FadeInWrapper>
      )}
    </Placeholder>
  );
};

export default memo(Player);
